<template>
  <div class="container1">
    <div v-if="!isCovertMode" class="img-wrapper">
      <img src="../assets/img/d.png"/>
    </div>
    <div class="login-box">
      <div class="tags">
        <div
          class="tag"
          v-bind:class="loginType==0?'active':''"
          v-on:click="typeChange"
          data-type="0"
        >账号密码登录</div>
        <div
          class="tag"
          v-bind:class="loginType==1?'active':''"
          v-on:click="typeChange"
          data-type="1"
        >短信验证码登录</div>
      </div>
    </div>
    <div class="container-form">
      <template v-if="loginType==0">
        <van-form @submit="onSubmit">
          <van-field
            v-model="username"
            name="用户名"
            label="用户名"
            left-icon="manager-o"
          />
          <van-field
            v-model="password"
            type="password"
            name="密码"
            label="密码"
            left-icon="closed-eye"
          />
          <div style="margin: 16px;">
            <van-button
              class-prefix="my-btn"
              round
              block
              type="primary"
              native-type="submit"
              :disabled="loginLoading"
              :loading="loginLoading"
              v-on:click="goLogin"
            >登录</van-button>
          </div>
					<div style="margin: 16px;">
            <van-button round block type="info" v-on:click="goRegistPage">注册</van-button>
					</div>
          
        </van-form>
      </template>
      <template v-else>
        <van-form @submit="onSubmit">
          <van-field
            v-model="phone"
            name="手机号"
            label="手机号"
            left-icon="user-o"
            label-class="field-w"
          >
            <van-button
              slot="button"
              size="small"
              type="primary"
              @click="sendVerifycode()"
              :disabled="!disabledCodeBtn"
            >{{codeText}}</van-button>
          </van-field>
        </van-form>
        <van-form>
          <van-field
            v-model="verifycode"
            type="password"
            name="验证码"
            label="验证码"
            left-icon="chat-o"
          />
          <div style="margin: 16px;">
            <van-button round block type="primary" native-type="submit" :disabled="loginLoading"
              :loading="loginLoading" loading-text="加载中..." v-on:click="goLogin">登录</van-button>
          </div>
          
        </van-form>
      </template>
      <div style="margin: 16px;text-align:right;color:#01A1E9">
        <!-- <van-button round block class="btn-reset" v-on:click="goReset">忘记密码</van-button> -->
        <span class="forget" v-on:click="goReset">忘记密码</span>
      </div>
    </div>
  </div>
  
</template>
<script>
import Vue from "vue";
import Vuex from 'vuex'
import { app } from "../../utils/app";
import { Form, Field, Button, CellGroup, Toast,Dialog,Overlay } from "vant";
import { getValidateCode,shopLogin } from "../../utils/api";
Vue.use(Vuex)
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(Overlay);

export default {
  data() {
    return {
      username: "", //用户名
      password: "", //密码
      phone: "", //手机号
      verifycode: "", //验证码
      loginType: 0, //登录方式0账号密码1手机号验证码
      codeText: "验证码",
      disabledCodeBtn: true,
      token: "",
      showToken:"",
      show:false,
      isCovertMode:this.$isCovertMode,
      loginLoading:false
    };
  },
  async created() {
    // app.storage.set("token", "bd73938c37ec421fa545e530990d4cf4");
    //获取用户token
    let userToken = app.getUserToken();
    let shopToken = app.getShopToken();
    this.token = userToken;
    this.shopToken = shopToken;
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
    },
    typeChange(e) {
      console.log(e.target.dataset.type);
      this.loginType = e.target.dataset.type;
    },
    // 向后台要验证码方法
    async sendVerifycode() {
      if(this.verifyPhone()){
        Toast(this.verifyPhone())
      }else{
        let params = {
          mobileNo: this.phone,
          token: this.token,
        };
        let res = await getValidateCode(params);
        //  用手机号向后台换取验证码，发送成功则开始调用倒计时分方法
        if (res) {
          this.countDown(60);
          Toast(res.data.message)
        }
      }
    },
    // 表单校验方法
    verifyPhone() {
      if (!this.phone) {
        return "请输入手机号";
      } else if (this.phone.length !== 11) {
        return "请输入11位手机号";
      } else {
        return false;
      }
    },
    // 倒计时方法
    countDown(time) {
      if (time === 0) {
        this.disabledCodeBtn = true;
        this.codeText = "验证码";
        return;
      } else {
        this.disabledCodeBtn = false;
        this.codeText = "发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },
    // 登录
    async goLogin() {
      let params;
      if (this.loginType == 0) {
        params = {
          username: this.username,
          password: this.password,
          loginType: 0,
        };
      } else {
        params = {
          username: this.phone,
          password: this.verifycode,
          loginType: 1,
        };
      }
      this.loginLoading = true
      let res1 = await shopLogin(params)
      console.log('res1',res1,res1.data.msg)
      if(res1.status == 200){//登录成功
        if(res1.data.code == 0){
          let shopToken = res1.data.usertoken
					let userInfo = res1.data.user
          let shopInfo = res1.data.shop
          // let deviceFlag = res1.data.deviceFlag || ''
					this.$store.commit('setShopToken',shopToken)
					// this.$store.commit('setUserInfo',userInfo)
					this.$store.commit('setShopInfo',shopInfo)
          app.storage.set("shopToken", shopToken)
          app.storage.set("shopInfo", shopInfo)
          app.storage.set("shopUserInfo",userInfo)
          // app.storage.set("deviceFlag",deviceFlag)
					this.$router.push({path:'/ShopData'})
        }else{
          Dialog.alert({
            message: res1.data.msg
          }).then(() => {
            console.log('用户确认')
          });
        }
        this.loginLoading = false
      }else{
        this.loginLoading = false
        Dialog.alert({
          message: res1.data.msg
        }).then(() => {
          console.log('用户确认')
        });
      }
    },
    getValidateCode() {},
    overlayClick(){
      this.show = false
    },
		goRegistPage(){
			this.$router.push('/ShopRegist');
    },
    //重置密码
    goReset(){
      this.$router.push('/ShopResetPassword');
    }
  },
};
</script>
<style lang="less">
@field-label-width:3rem;
.container1 {
  background-color: #ffffff;
  .img-wrapper {
    background-color: #ffffff;
    text-align: center;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 40%;
    }
  }
  .body .img1-box img {
    width: 100%;
  }
  .body .img2-box img {
    width: 100%;
  }
  .login-box {
    .tags {
      display: flex;
      justify-content: space-around;
      padding: 0 30px;
      .tag {
        text-align: center;
        font-size: 16px;
        height: 22px;
        padding: 0 10px;
        line-height: 22px;
        color: #888888;
        box-sizing: border-box;
        &.active {
          font-size: 16px;
          color: #333333;
          border-bottom: 1px solid #dedede;
        }
      }
    }
  }
  .container-form {
    padding: 10px 20px;
    .van-button--small {
      height: 24px;
      line-height: 24px;
    }
    .btn-reset{
      width: 40%;
      float: right;
      color: #aaaaaa;
    }
    .van-field__label{
      width: 4rem;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 320px;
    height: 360px;
    padding: 40px 20px 20px 20px;
    background-color: #fff;
    border-radius: 20px;
    font-size: 22px;
    .title{
      font-size: 26px;
    text-align: center;
    }
    .title2{
      font-size: 20px;
      margin-top: 20px;
      text-align: left;
    }
    .url{
      font-size: 24px;
      font-weight: bold;
      color:#0364e4;
      text-align: left;
    }
    .bot{
      text-align: right;
      color: #FF3366;
      font-size: 22px;
      margin-top: 100px;
      font-weight: bold;
    }
  }
}
</style>
